import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      nav: {
        home: 'Home',
        about: 'About',
        skills: 'Skills',
        projects: 'Projects',
        experience: 'Experience',
        education: 'Education',
        resume: 'Resume',
        contact: 'Contact'
      },
      hero: {
        greeting: "Hi, I'm",
        title: 'Full Stack Developer',
        subtitle: 'Transforming ideas into digital solutions with 7 years of experience',
        cta: 'View Projects',
        contact: 'Get in Touch',
        dataPortfolio: 'View Data Portfolio'
      },
      about: {
        title: 'About Me',
        description: "I'm a full stack developer based in São Paulo, Brazil, with 7 years of experience in creating innovative solutions. My greatest passion is technology and the possibilities it opens to the world around us, especially the way I can use it to transform people's lives.",
        yearsExperience: 'Years Experience',
        projectsCompleted: 'Projects Completed',
        technologiesMastered: 'Technologies Mastered'
      },
      skills: {
        title: 'Skills & Technologies',
        frontend: 'Frontend',
        backend: 'Backend',
        tools: 'Tools & Others'
      },
      projects: {
        title: 'Featured Projects',
        viewAll: 'View All Projects',
        viewCode: 'View Code',
        liveDemo: 'Live Demo'
      },
      experience: {
        title: 'Professional Experience',
        experiences: [
          {
            company: 'BRQ',
            role: 'Senior Technical Consultant',
            period: 'Nov 2025',
            description: 'Technical Consultant in the financial services domain, working on the maintenance, optimization, and evolution of mission-critical systems. I leverage AWS services (Lambda, Glue, Athena, S3, Secrets Manager) and FICO DMPS to maintain decisioning platforms, implement new features, and improve performance, scalability, and reliability of client products. Experienced in troubleshooting production systems and collaborating with cross-functional teams to deliver high-impact technical solutions.',
            technologies: ['AI', 'Terraform', 'JavaScript', 'Python', 'PySpark', 'AWS', 'Databricks', 'DMPS']
          },
          {
            company: 'Mobicity',
            role: 'Full Stack Developer',
            period: 'Jan 2022 - Nov 2025',
            description: 'Full-stack developer with experience building scalable web and mobile applications using Node.js, React, RESTful APIs, and AWS. Improved system performance through query optimization and efficient data processing, while collaborating with cross-functional teams to deliver high-quality features ahead of schedule.',
            technologies: ['React', 'Node.js', 'MongoDB', 'JavaScript', 'Redis']
          },
          {
            company: 'Management Solutions',
            role: 'Technology Consultant',
            period: 'Apr 2021 - Apr 2022',
            description: 'Data and backend-focused developer with experience in banking projects, working with decision engines, data pipelines, and cloud platforms. Strong background in ETL optimization, policy parameterization, and aligning technical solutions with business requirements while supporting team enablement through documentation and training.',
            technologies: ['React', 'Node.js', 'JavaScript', 'Java', 'MySQL', 'AWS']
          },
          {
            company: 'Self Employed',
            role: 'Self Employed',
            period: 'Oct 2020 - Mar 2021',
            description: 'Entrepreneur and digital specialist with experience founding and managing a digital agency focused on traffic management, e-commerce optimization, and web development. Proven track record of delivering high-ROI paid media campaigns and creating customized digital solutions that boost conversion rates and brand visibility.',
            technologies: ['HTML', 'CSS', 'JavaScript', 'Facebook ADS']
          },
          {
            company: 'Permute',
            role: 'Technical Support Intern',
            period: 'Apr 2019 - Sep 2020',
            description: 'Backend developer with experience building and maintaining ASP.NET Core systems, integrating server-side solutions with front-end technologies such as HTML, JavaScript, jQuery, and Bootstrap.',
            technologies: ['ASP.Net Core', 'Java', 'JQuery', 'Bootstrap', 'JavaScript', 'Model-View-Controller (MVC)']
          }
        ]
      },
      education: {
        title: 'Education & Certifications',
        degrees: {
          computerScience: {
            title: 'Bachelor of Computer Science',
            description: 'Complete education in Computer Science, with focus on software development, algorithms, data structures, software engineering, databases and fundamentals of computing.'
          },
          ai: {
            title: 'Artificial Intelligence',
            description: 'Certification focused on Artificial Intelligence, covering practical AI fundamentals, modern tools and real-world applications for product and software development.'
          },
          aiProductivity: {
            title: 'AI-Powered Productivity',
            description: 'Certification focused on AI-powered productivity, covering tools such as Codeium, Amazon Q Developer and GitHub Copilot for writing better code.'
          },
          aiNative: {
            title: 'AI Native Development',
            description: 'Certification focused on AI Native development, covering Copilot, MCP, agents, tasks and skills for building modern software solutions.'
          },
          react: {
            title: 'React',
            description: 'Advanced React certification covering component architecture, advanced hooks, performance optimization, and state management patterns for scalable applications.'
          },
          nodeFoundations: {
            title: 'Node.js Foundations',
            description: 'Certification in Node.js fundamentals, covering REST APIs, streams, middlewares and backend development with JavaScript.'
          },
          reactFoundations: {
            title: 'React Foundations',
            description: 'Certification in React fundamentals, covering components, hooks, state, props and development of modern and reactive interfaces.'
          },
          reactNativeFoundations: {
            title: 'React Native Foundations',
            description: 'Certification in React Native fundamentals, focused on cross-platform mobile development, native components and styling.'
          },
          microservices: {
            title: 'Scalable Microservices',
            description: 'Certification in microservices architecture, covering design patterns, service communication, scalability and best practices.'
          },
          reactNativeAdvanced: {
            title: 'Interfaces, Navigation and Local Storage',
            description: 'Certification focused on React Native, exploring mobile interface creation, screen navigation and local data persistence.'
          }
        }
      },
      resume: {
        title: 'Download Resume',
        subtitle: 'Get my full professional resume in your preferred language',
        download: 'Download PDF',
        portuguese: 'Portuguese Version',
        english: 'English Version'
      },
      contact: {
        title: 'Get In Touch',
        subtitle: "Let's work together on your next project",
        name: 'Name',
        email: 'Email',
        message: 'Message',
        send: 'Send Message',
        success: 'Message sent successfully!',
        error: 'Error sending message. Please try again.'
      },
      footer: {
        rights: 'All rights reserved',
        madeWith: 'Made',
        by: 'by'
      }
    }
  },
  pt: {
    translation: {
      nav: {
        home: 'Início',
        about: 'Sobre',
        skills: 'Habilidades',
        projects: 'Projetos',
        experience: 'Experiência',
        education: 'Educação',
        resume: 'Currículo',
        contact: 'Contato'
      },
      hero: {
        greeting: 'Olá, eu sou',
        title: 'Desenvolvedor Full Stack',
        subtitle: 'Transformando ideias em soluções digitais com 7 anos de experiência',
        cta: 'Ver Projetos',
        contact: 'Entre em Contato',
        dataPortfolio: 'Ver Portfólio de Dados'
      },
      about: {
        title: 'Sobre Mim',
        description: 'Sou um desenvolvedor full stack baseado em São Paulo, Brasil, com 7 anos de experiência na criação de soluções inovadoras. Minha maior paixão é a tecnologia e as possibilidades que ela abre para o mundo ao nosso redor, especialmente a forma como posso usá-la para transformar a vida das pessoas.',
        yearsExperience: 'Anos de Experiência',
        projectsCompleted: 'Projetos Concluídos',
        technologiesMastered: 'Tecnologias Dominadas'
      },
      skills: {
        title: 'Habilidades & Tecnologias',
        frontend: 'Frontend',
        backend: 'Backend',
        tools: 'Ferramentas & Outros'
      },
      projects: {
        title: 'Projetos em Destaque',
        viewAll: 'Ver Todos os Projetos',
        viewCode: 'Ver Código',
        liveDemo: 'Demo Ao Vivo'
      },
      experience: {
        title: 'Experiência Profissional',
        experiences: [
          {
            company: 'BRQ',
            role: 'Consultor Técnico Senior',
            period: 'Nov 2025',
            description: 'Consultor Técnico Senior atuando no setor de serviços financeiros, responsável pela manutenção, otimização e evolução de sistemas críticos para o negócio. Utilizo serviços da AWS (Lambda, Glue, Athena, S3, Secrets Manager) e FICO DMPS para manter plataformas de decisão, implementar novas funcionalidades e melhorar o desempenho, a escalabilidade e a confiabilidade dos produtos dos clientes. Possuo experiência na resolução de problemas em ambientes de produção e na colaboração com equipes multidisciplinares para entregar soluções técnicas de alto impacto.',
            technologies: ['IA', 'Terraform', 'JavaScript', 'Python', 'PySpark', 'AWS', 'Databricks', 'DMPS']
          },
          {
            company: 'Mobicity',
            role: 'Desenvolvedor Full Stack',
            period: 'Jan 2022 - Nov 2025',
            description: 'Desenvolvedor full-stack com experiência na criação de aplicações web e mobile escaláveis utilizando Node.js, React, APIs REST e serviços AWS. Focado em otimização de desempenho, eficiência no processamento de dados e colaboração com equipes multidisciplinares para entregar soluções de alta qualidade dentro do prazo.',
            technologies: ['React', 'Node.js', 'MongoDB', 'JavaScript', 'Redis']
          },
          {
            company: 'Management Solutions',
            role: 'Consultor de Tecnologia',
            period: 'Abr 2021 - Abr 2022',
            description: 'Desenvolvedor com foco em dados e backend, com experiência em projetos bancários, atuando em motores de decisão, pipelines de dados e plataformas em nuvem. Especialista em otimização de ETL, parametrização de regras e alinhamento entre requisitos de negócio e entrega técnica, além de apoio ao time por meio de documentação e treinamentos.',
            technologies: ['Python', 'PySpark', 'JavaScript', 'Java', 'Azure', 'FICO']
          },
          {
            company: 'Autônomo',
            role: 'Autônomo',
            period: 'Out 2020 - Mar 2021',
            description: 'Empreendedor e especialista digital com experiência na fundação e gestão de uma agência digital, atuando com gestão de tráfego, otimização de e-commerce e desenvolvimento web. Histórico comprovado na execução de campanhas de mídia paga com alto ROI e na entrega de soluções personalizadas que aumentam conversão e visibilidade de marca.',
            technologies: ['HTML', 'CSS', 'JavaScript', 'Facebook ADS']
          },
          {
            company: 'Permute',
            role: 'Suporte Técnico',
            period: 'Abr 2019 - Set 2020',
            description: 'Desenvolvedor backend com experiência no desenvolvimento e manutenção de sistemas em ASP.NET Core, integrando soluções de servidor com tecnologias de front-end como HTML, JavaScript, jQuery e Bootstrap.',
            technologies: ['ASP.Net Core', 'Java', 'JQuery', 'Bootstrap', 'JavaScript', 'Model-View-Controller (MVC)']
          }
        ]
      },
      education: {
        title: 'Educação & Certificações',
        degrees: {
          computerScience: {
            title: 'Bacharelado em Ciências da Computação',
            description: 'Formação completa em Ciências da Computação, com foco em desenvolvimento de software, algoritmos, estruturas de dados, engenharia de software, banco de dados e fundamentos de computação.'
          },
          ai: {
            title: 'Inteligência Artificial',
            description: 'Certificação focada em Inteligência Artificial, cobrindo fundamentos práticos de IA, ferramentas modernas e aplicações reais para desenvolvimento de produtos e software.'
          },
          aiProductivity: {
            title: 'Produtividade com IA',
            description: 'Certificação focada em produtividade com inteligência artificial, abordando ferramentas como Codeium, Amazon Q Developer e GitHub Copilot para escrever códigos melhores.'
          },
          aiNative: {
            title: 'Desenvolvimento AI Native',
            description: 'Certificação focada em desenvolvimento AI Native, abordando Copilot, MCP, agentes, tasks e skills para criar soluções modernas de software.'
          },
          react: {
            title: 'React',
            description: 'Certificação avançada em React abordando arquitetura de componentes, hooks avançados, otimização de performance e padrões de gerenciamento de estado para aplicações escaláveis.'
          },
          nodeFoundations: {
            title: 'Fundamentos do Node.js',
            description: 'Certificação em fundamentos do Node.js, cobrindo APIs REST, streams, middlewares e desenvolvimento backend com JavaScript.'
          },
          reactFoundations: {
            title: 'Fundamentos do React',
            description: 'Certificação em fundamentos do React, abordando componentes, hooks, estado, props e desenvolvimento de interfaces modernas e reativas.'
          },
          reactNativeFoundations: {
            title: 'Fundamentos do React Native',
            description: 'Certificação em fundamentos de React Native, com foco em desenvolvimento mobile multiplataforma, componentes nativos e estilização.'
          },
          microservices: {
            title: 'Microsserviços Escaláveis',
            description: 'Certificação em arquitetura de microsserviços, abordando design patterns, comunicação entre serviços, escalabilidade e boas práticas.'
          },
          reactNativeAdvanced: {
            title: 'Interfaces, Navegação e Armazenamento local',
            description: 'Certificação focada em React Native, explorando criação de interfaces mobile, navegação entre telas e persistência de dados local.'
          }
        }
      },
      resume: {
        title: 'Baixar Currículo',
        subtitle: 'Obtenha meu currículo profissional completo no idioma de sua preferência',
        download: 'Baixar PDF',
        portuguese: 'Versão em Português',
        english: 'Versão em Inglês'
      },
      contact: {
        title: 'Entre em Contato',
        subtitle: 'Vamos trabalhar juntos no seu próximo projeto',
        name: 'Nome',
        email: 'Email',
        message: 'Mensagem',
        send: 'Enviar Mensagem',
        success: 'Mensagem enviada com sucesso!',
        error: 'Erro ao enviar mensagem. Por favor, tente novamente.'
      },
      footer: {
        rights: 'Todos os direitos reservados',
        madeWith: 'Feito com',
        by: 'por'
      }
    }
  }
};

const systemLanguage = typeof navigator !== 'undefined'
  ? (navigator.languages?.[0] || navigator.language || 'en').toLowerCase()
  : 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: systemLanguage.startsWith('pt') ? 'pt' : 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
